/*---------------------------------------------------------*\
 * News12ButtonController
 \*---------------------------------------------------------*/
const deps = {};

class NewsTickerController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor($timeout, $filter, $document) {
    this.name = 'newsTicker';

    this.pxPerSecond = this.speed || 'default';

    this.texts = [];

    deps.$timeout = $timeout;
    deps.$filter = $filter;
    deps.$document = $document;

    this.gap = 150;
    this.padding = 20;

    this.animFrame = window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        null;
  }

  //-----------------------------------
  // Properties
  //-----------------------------------
  set type(value) {
    this.types = this.types || {
      INFOBAR: {
        className: 'infobar'
      },
      'WEATHER ALERT': {
        className: 'weather-alert'
      },
      'TRAFFIC ALERT': {
        className: 'traffic-alert'
      },
      'BREAKING NEWS': {
        className: 'breaking-news'
      }
    };

    this._type = this.types[value];

    if (this.header) {
      this.resizeHandler();
    }
  }

  get type() {
    return this._type;
  }

  set data(value) {
    this._data = value;

    if (this.header) {
      this.resizeHandler();
    }
  }

  get data() {
    return this._data;
  }

  //-----------------------------------
  // Lifecycle
  //-----------------------------------
  $postLink() {
    window.addEventListener('resize', this.resizeHandler.bind(this));

    this.animFrame.call(window, this.onFrameFirstHandler.bind(this));

    this.resizeHandler();
  }

  //-----------------------------------
  // Methods
  //-----------------------------------
  addText() {
    if (this.wrapper) {
      this.texts = this.texts || [];

      const element = deps.$document[0].createElement('div');

      element.setAttribute('class', 'data');

      element.innerHTML = deps.$filter('htmlToPlaintext')(this.data);

      this.wrapper.appendChild(element);

      this.texts.push({
        element,
        width: element.offsetWidth,
        x: this.wrapper.offsetWidth
      });
    }
  }

  removeText(text) {
    this.wrapper.removeChild(text.element);
  }

  //-----------------------------------
  // Events
  //-----------------------------------
  resizeHandler() {
    this.wrapper = this.wrapper || deps.$document[0].getElementsByClassName('ticker-wrapper')[0];
    this.header = this.header || deps.$document[0].getElementsByClassName('ticker-header')[0];
    this.headerContent = this.headerContent || deps.$document[0].getElementsByClassName('ticker-header-content')[0];

    if (this._type) {
      this.header.setAttribute('class', 'ticker-header ticker-header-' + this._type.className);
      this.wrapper.setAttribute('class', 'ticker-wrapper ticker-wrapper-' + this._type.className);
    }
  }

  onFrameFirstHandler() {
    this.lastTime = performance.now();

    this.animFrame.call(window, this.onFrameHandler.bind(this));
  }

  onFrameHandler() {
    const curTime = performance.now();

    this.elapsed = Math.min(0.5, (curTime - this.lastTime) / 1000);
    this.lastTime = curTime;

    const pxps = this.pxPerSecond === 'default' ? window.innerWidth / 16 : this.pxPerSecond;

    if (this.type && this.data) {
      // Display and shift each text item
      this.texts.forEach((text) => {
        text.x -= pxps * this.elapsed;

        text.element.setAttribute('style', 'left: ' + text.x + 'px;');
      });

      // Filter out all text items that are off the left edge.
      this.texts = this.texts.filter((text) => {
        const invalid = text.x + text.width + this.gap < 0;

        if (invalid) {
          this.removeText(text);
        }

        return !invalid;
      });

      const text = this.texts ? this.texts[this.texts.length - 1] : undefined;

      if (!text || (text.x + text.width + this.gap < this.wrapper.offsetWidth)) {
        this.addText();
      }
    }

    this.animFrame.call(window, this.onFrameHandler.bind(this));
  }
}

NewsTickerController.$inject = [
  '$timeout',
  '$filter',
  '$document'
];

export default NewsTickerController;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/newsTicker/newsTicker.controller.js
 **/